// BIGLI-110：LINE 新需求未讀通知的純函式與「立即重查」事件（側欄與列表頁共用）。

export const LINE_UNREAD_POLL_MS = 60 * 1000;
export const LINE_UNREAD_REFRESH_EVENT = 'line-unread-refresh';

/** 紅點上的數字：0 或無效值回 ''（不顯示紅點），超過 99 顯示 99+。 */
export const formatUnreadBadge = (n) => {
  const v = Number(n) || 0;
  if (v <= 0) return '';
  return v > 99 ? '99+' : String(v);
};

export const isUnreadInquiry = (inq) => !inq.readAt;

const receivedTime = (inq) => new Date(inq.receivedAt).getTime() || 0;

/** 未讀在前（詢問時間新到舊）→ 其餘依詢問時間新到舊。與後端 GET /inquiries 同規則，本地標已讀後重排用。 */
export const sortUnreadFirst = (list) => [...list].sort((a, b) => {
  const ua = isUnreadInquiry(a) ? 1 : 0;
  const ub = isUnreadInquiry(b) ? 1 : 0;
  if (ua !== ub) return ub - ua;
  return receivedTime(b) - receivedTime(a);
});

/** 門市 tab 的未讀數：「全部門市」＝total，其餘查 byStore。 */
export const unreadForTab = (counts, store) => {
  if (!counts) return 0;
  return store ? (counts.byStore?.[store] || 0) : (counts.total || 0);
};

/** 標記已讀後叫側欄立刻重查，不用等 60 秒輪詢。 */
export const requestLineUnreadRefresh = () => {
  window.dispatchEvent(new Event(LINE_UNREAD_REFRESH_EVENT));
};
